// extracted by mini-css-extract-plugin
module.exports = {"no-competitors":"NoCompetitors_no-competitors__25s7F","content":"NoCompetitors_content__6Ll2E","button":"NoCompetitors_button__2ymr9"};